export default __webpack_public_path__ + "static/media/MuseoSans_700-webfont.8aac8783.eot";